// src/components/dashboard/DashboardCard.tsx
import React, { useEffect, useState } from "react";
import axios from "axios";

interface DashboardCardProps {
    apiEndpoint: string; // ex: "/dashboard/total-bookings"
    icon: string;
    bgColor: string;
    label: string;
    colClass?: string; // 🆕 Classe opcional para colunas (ex: "col-xl-3 col-sm-6")
}

const DashboardCard: React.FC<DashboardCardProps> = ({ apiEndpoint, icon, bgColor, label, colClass }) => {
    const [value, setValue] = useState<string | number>("...");

    useEffect(() => {
        const fetchData = async () => {
            try {
                const token = localStorage.getItem("token");
                const res = await axios.get(`${process.env.REACT_APP_API_URL}${apiEndpoint}`, {
                    headers: token ? { Authorization: `Bearer ${token}` } : undefined,
                });
                setValue(res.data.value); // assume que o backend retorna { value: ... }
            } catch (error) {
                console.error(`Erro ao buscar ${label}:`, error);
            }
        };

        fetchData();
    }, [apiEndpoint, label]);

    return (
        <div className={colClass || "col-xl-4 col-sm-6 d-flex"}> {/* padrão para dashboard do usuário */}
            <div className="card shadow-none flex-fill">
                <div className="card-body text-center">
                    <span className={`avatar avatar rounded-circle ${bgColor} mb-2`}>
                        <i className={`isax ${icon} fs-24`} />
                    </span>
                    <h5 className="mb-2">
                        {typeof value === "number" && (label === "Total Transactions" || label === "Average Value")
                            ? `$${value.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
                            : value}
                    </h5>
                    <p className="mb-1">{label}</p>
                </div>
            </div>
        </div>
    );
};

export default DashboardCard;
